class LazyVideo extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: contents;

        opacity: 0;

        transition: opacity 0.5s ease;
      }
      :host([loaded]) {
        opacity: 1;
      }
    `
  }

  connectedCallback () {
    super.connectedCallback()

    this.video = window.BAO.Utils.getElement('video', { context: this })

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      threshold: 0,
      rootMargin: '200px',
    })
    // We can't observe the host element as it has display: contents on it. IntersectionObserver won't work on an element that is set to display: contents
    // We also can't observe the video element as it can overflow outside of the container when used in a full-screen-banner section with the sticky setting.
    // We can't can't the immediate parent node as this will also overflow if in a sticky full-screen-banner
    // Instead observe the second parentNode
    this.observeTarget = this.parentNode.parentNode
    this.observer.observe(this.observeTarget)
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    if (this.video.dataset.poster) {
      this.video.setAttribute('poster', this.video.dataset.poster)
    }

    for (const source in this.video.children) {
      const videoSource = this.video.children[source]

      if (
        typeof videoSource.tagName === 'string' &&
        videoSource.tagName === 'SOURCE'
      ) {
        videoSource.src = videoSource.dataset.src
      }
    }

    this.video.load()
    observer.unobserve(this.observeTarget)

    this.setAttribute('loaded', '')

    if (
      this.video.hasAttribute('autoplay') === false ||
      !this.autoplayOnLowPower
    ) {
      return
    }

    if (!this.video.paused) return

    if (this.video.duration >= 5) {
      this.video.controls = true
    }

    if (
      window.innerWidth > 768 &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      this.video.play()
      return
    }

    document.addEventListener('touchstart', () => {
      if (this.video.paused) {
        this.video.play()
      }
    })
  }

  /** @returns {string} */
  get alt () {
    return this.getAttribute('alt')
  }

  /**
   * Default to `true` if element doesn't have
   * 'autoplay-on-low-power' attribute
   */
  get autoplayOnLowPower () {
    const attribute = 'autoplay-on-low-power'
    const attributeValue = this.getAttribute(attribute) === 'true'

    return this.hasAttribute(attribute) ? attributeValue : true
  }
}

if (!customElements.get('lazy-video')) {
  customElements.define('lazy-video', LazyVideo)
}
